import React, { useState, useEffect } from 'react';
import debounce from 'lodash/debounce';
import { Grid, Autocomplete, TextField } from '@mui/material';

import { useGetAllTherapists } from '@/api/booking/staff';
import { StaffTherapistResponse } from '@/api/booking/booking-api.schemas';

export const TherapistSelector = props => {
  const { name, onChange, selectedTherapist, hideTherapist, disabled } = props;
  const [options, setOptions] = useState<any>([]);
  const [therapists, setTherapists] = useState<any>([]);
  const [defaultInputValue, setDefaultInputValue] = useState(null);
  const [searchName, setSearchName] = useState('');

  const { data: therapistsData, isLoading: therapistDataLoading } =
    useGetAllTherapists({ name: searchName });

  useEffect(() => {
    if (therapistsData?.data) {
      setOptions(mapTherapistToOptions(therapistsData.data));
      setTherapists(therapistsData.data);
    }
  }, [therapistsData]);

  useEffect(() => {
    if (selectedTherapist) {
      const therapist = {
        id: selectedTherapist?.id,
        name: selectedTherapist?.name
      };
      setDefaultInputValue(therapist);
      setOptions([therapist]);
    }
  }, []);

  const getOptionsDelayed = React.useCallback(
    debounce((text: string) => {
      setSearchName(text);
    }, 500),
    []
  );

  const mapTherapistToOptions = (data: StaffTherapistResponse[]) => {
    return data
      ?.filter(item => item?.id)
      .map(item => {
        return {
          id: item?.id,
          name: item?.name
        };
      });
  };

  const handleAutocomplete = (event, newValue) => {
    const therapist = therapists.find(c => c?.id === newValue?.id);
    if (newValue != null) {
      onChange({
        ...event,
        ...{ target: { value: newValue?.id, name }, therapist }
      });
    }
  };

  const hideTherapistIds = (hideTherapist || []).map(c => c?.node?.id);

  const filteredOptions = options.filter(
    o => hideTherapistIds.indexOf(o?.id) < 0
  );

  return (
    <Grid container>
      <Grid item xs={12}>
        <Autocomplete
          key={defaultInputValue}
          disabled={disabled}
          options={therapistDataLoading ? [] : filteredOptions}
          onChange={handleAutocomplete}
          loading={therapistDataLoading}
          defaultValue={defaultInputValue}
          getOptionLabel={options => options.name}
          renderInput={params => (
            <TextField
              key={params.id}
              fullWidth
              {...params}
              label="Search Therapists..."
              onChange={e => getOptionsDelayed(e.target.value)}
            />
          )}
        />
      </Grid>
    </Grid>
  );
};

TherapistSelector.defaultProps = {
  hideTherapist: []
};
